import React, { useCallback, useEffect, useState } from "react";
import {
  contactDeliveryUrl,
  contactsCsvUrl,
  getAvailability,
  listContacts,
  markContactSent,
} from "../lib/api";
import { ContactsTable } from "../components/contacts/ContactsTable";
import { toast } from "sonner";

export default function ContactsPage() {
  const [contacts, setContacts] = useState([]);
  const [availability, setAvailability] = useState({ lead_magnet_available: false });

  const loadContacts = useCallback(async () => {
    try {
      const data = await listContacts();
      setContacts(data);
    } catch (error) {
      toast.error("No se han podido cargar los contactos.");
    }
  }, []);

  useEffect(() => {
    getAvailability().then(setAvailability).catch(() => undefined);
    loadContacts();
  }, [loadContacts]);

  const sent = async (id) => {
    try {
      await markContactSent(id);
      await loadContacts();
    } catch (error) {
      toast.error(error.response?.data?.detail || "No se ha podido actualizar el contacto.");
    }
  };


  return (
    <main className="max-w-[1280px] mx-auto px-6 lg:px-10 py-16 lg:py-20">
      <div className="flex flex-wrap justify-between gap-6 items-end">
        <div>
          <div className="wk-eyebrow mb-4">Panel de contactos</div>
          <h1 className="text-[42px] lg:text-[56px] font-extrabold tracking-hero leading-[1.05]" style={{ color: "#1E1924" }} data-testid="contacts-title">
            Contactos
          </h1>
        </div>
        <button
          className="wk-btn wk-btn-ghost"
          onClick={() => window.open(contactsCsvUrl(), "_blank", "noopener")}
          data-testid="contacts-export-csv-button"
        >
          Exportar CSV
        </button>
      </div>

      <ContactsTable
        contacts={contacts}
        leadMagnetAvailable={availability.lead_magnet_available}
        onDelivery={(id, channel) => {
          window.open(contactDeliveryUrl(id, channel), "_blank", "noopener");
        }}
        onMarkSent={sent}
      />
    </main>
  );
}